(function () {
  var root = document.getElementById('ssx-body');
  if (!root) return;
  var handle = root.getAttribute('data-handle');

  /* FAQ: h3 -> accordions */
  if (handle === 'faq') {
    var searchEl = root.querySelector('.ssx-search');
    var noResEl = root.querySelector('.ssx-noresults');
    var kids = Array.prototype.slice.call(root.children).filter(function (el) {
      return el !== searchEl && el !== noResEl;
    });
    var frag = document.createDocumentFragment();
    var accBody = null;
    kids.forEach(function (el) {
      if (el.tagName === 'H2') {
        accBody = null;
        el.classList.add('ss-faq-group');
        frag.appendChild(el);
      } else if (el.tagName === 'H3') {
        var details = document.createElement('details');
        details.className = 'ss-acc';
        details.setAttribute('data-q', el.textContent.toLowerCase());
        var summary = document.createElement('summary');
        summary.className = 'ss-acc__summary';
        summary.textContent = el.textContent.trim();
        var bodyDiv = document.createElement('div');
        bodyDiv.className = 'ss-acc__body';
        details.appendChild(summary);
        details.appendChild(bodyDiv);
        frag.appendChild(details);
        accBody = bodyDiv;
      } else if (accBody) {
        accBody.appendChild(el);
      } else {
        frag.appendChild(el);
      }
    });
    root.textContent = '';
    if (searchEl) root.appendChild(searchEl);
    if (noResEl) root.appendChild(noResEl);
    root.appendChild(frag);
    /* live search */
    var q = document.getElementById('ssx-q');
    if (q) {
      q.addEventListener('input', function () {
        var term = q.value.trim().toLowerCase();
        var items = root.querySelectorAll('.ss-acc');
        var shown = 0;
        var groupMap = {};
        items.forEach(function (it) {
          var hit = !term || it.getAttribute('data-q').indexOf(term) > -1 ||
            it.querySelector('.ss-acc__body').textContent.toLowerCase().indexOf(term) > -1;
          it.style.display = hit ? '' : 'none';
          if (hit) { shown++; it.open = !!term; } else { it.open = false; }
          var g = it.previousElementSibling;
          while (g && !g.classList.contains('ss-faq-group')) g = g.previousElementSibling;
          if (g) {
            var key = g.textContent;
            if (!groupMap[key]) groupMap[key] = { el: g, n: 0 };
            if (hit) groupMap[key].n++;
          }
        });
        Object.keys(groupMap).forEach(function (k) { groupMap[k].el.style.display = groupMap[k].n ? '' : 'none'; });
        var nr = document.getElementById('ssx-noresults');
        if (nr) nr.hidden = shown !== 0;
      });
    }
  }

  /* Policies: table of contents */
  if (handle === 'policy') {
    var nav = document.getElementById('ssx-tocnav');
    if (nav) {
      var heads = root.querySelectorAll('h2');
      heads.forEach(function (h, i) {
        var id = 'ssx-sec-' + i;
        h.id = id;
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        a.addEventListener('click', function (e) {
          e.preventDefault();
          document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        nav.appendChild(a);
      });
      var links = nav.querySelectorAll('a');
      function onScroll() {
        var cur = null;
        heads.forEach(function (h) { if (h.getBoundingClientRect().top < 120) cur = h.id; });
        links.forEach(function (a) { a.classList.toggle('ssx-active', a.getAttribute('href') === '#' + cur); });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    root.querySelectorAll('h2').forEach(function (h) { h.style.scrollMarginTop = '24px'; });
  }
})();
